import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import DashboardNew from './DashboardNew';
import DashboardClassic from './DashboardClassic';
import DashboardOverview from './DashboardOverview';
import { useTheme } from '../context/ThemeContext';
import { usePosthogOrgIdentify } from '../hooks/usePosthogOrgIdentify';

/**
 * /dashboard — the tabbed dashboard on both looks (DashboardNew under the
 * inset shell, DashboardClassic otherwise). Under the New look the first tab,
 * Overview (/dashboard/overview), is the Analytics page; Classic has no such
 * tab and lands on the tabbed dashboard instead. The Analytics page also
 * stays on /analytics as its own page.
 */
export default function Dashboard() {
  const { insetActive } = useTheme();
  const { pathname } = useLocation();
  usePosthogOrgIdentify();
  const overview = pathname === '/dashboard/overview';
  if (!insetActive) return overview ? <Navigate to="/dashboard" replace /> : <DashboardClassic />;
  return overview ? <DashboardOverview /> : <DashboardNew />;
}
